import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import patientStore from '@/store/records/patientStore'
import prescriptionStore from '@/store/records/prescriptionStore'
import historyStore from '@/store/records/historyStore'
import settingsChatStore from '@/store/chat/settingsChatStore'
import queueChatStore from '@/store/specialist/queueSpecilist.store'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'
import dashboard from './dashboard'
import pages from './pages'
import registerCustomer from './register-customer'
import observerMenssag from './observerMenssage'
import chat from './chat'
import principal from './Customer/principal.store'
import posts from './Customer/posts.store'
import localAtendimento from './specialist/localAtendimento.store'
import historicoMovimentacao from './specialist/historicoMovimentacao.store'
import error_log from './error-log'
import bankAcount from './bankAccount'
import prontuario from './prontuario'
import record from './records/recordsStore'
import anamneseStore from './records/anamneseStore'
import conductStore from './records/conductStore'
import guidanceStore from './records/guidanceStore'
import availableTime from './calender/availableTime.store'
import videoCall from './records/videoCallStore'
import patientArea from './Customer/patientArea.store'
import memedStore from './records/memedStore'
import profileStore from './profile.store'
import reimbursementStore from './Customer/reimbursement.store'
import specialistChatStore from './chat/specialistChatStore'
import customerChatStore from './chat/customerChatStore'
import companiesSpecialist from './specialist/companiesSpecialist.store'
import companiesAdmin from './specialist/companiesAdmin.store'
import createCard from './Customer/createCard.store'
import cid from './cid/index'
import notification from './notification/index'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    dashboard,
    pages,
    registerCustomer,
    observerMenssag,
    chat,
    principal,
    posts,
    localAtendimento,
    historicoMovimentacao,
    error_log,
    bankAcount,
    prontuario,
    record,
    patientStore,
    anamneseStore,
    conductStore,
    prescriptionStore,
    guidanceStore,
    availableTime,
    videoCall,
    patientArea,
    memedStore,
    profileStore,
    historyStore,
    reimbursementStore,
    specialistChatStore,
    customerChatStore,
    settingsChatStore,
    queueChatStore,
    companiesSpecialist,
    companiesAdmin,
    createCard,
    cid,
    notification,
  },
  strict: process.env.DEV,
})
